import { render, staticRenderFns } from "./deliveryHours.vue?vue&type=template&id=c97627e4&scoped=true&"
import script from "./deliveryHours.vue?vue&type=script&lang=js&"
export * from "./deliveryHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97627e4",
  null
  
)

export default component.exports